module.exports = __webpack_public_path__ + "media/images/the-information-pro-logo-46f876e1.svg";